// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/";
const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "login"),
  register: path(ROOTS_AUTH, "register"),
  verification: path(ROOTS_AUTH, "verification"),
  resetPassword: path(ROOTS_AUTH, "reset-password"),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    dashboard: path(ROOTS_DASHBOARD, "/"),
    authUsers: path(ROOTS_DASHBOARD, "/sub-admin"),
    regUsers: path(ROOTS_DASHBOARD, "/users"),
    regUserEdit: path(ROOTS_DASHBOARD, "/reg-user-edit"),
    deleteRequestUserList: path(ROOTS_DASHBOARD, "/delete-req-user"),
    deleteUserList: path(ROOTS_DASHBOARD, "/delete-user"),

    authUserEdit: path(ROOTS_DASHBOARD, "/auth-user-edit"),

    rolePermission: path(ROOTS_DASHBOARD, "/roles"),
    permission: path(ROOTS_DASHBOARD, "/permission"),

    foodCategory: path(ROOTS_DASHBOARD, "/food-sub-categories"),
    groceryCategory: path(ROOTS_DASHBOARD, "/grocery-sub-categories"),
    mainCategory: path(ROOTS_DASHBOARD, "/main-category"),
    vendor: path(ROOTS_DASHBOARD, "/vendor"),
    getProfile: path(ROOTS_DASHBOARD, "/getProfile"),

    changePassword: path(ROOTS_DASHBOARD, "/changePassword"),
    approved_vendor: path(ROOTS_DASHBOARD, "/vendor/approved"),
    approvedKYC: path(ROOTS_DASHBOARD, "/vendor/approved-kyc"),
    pendingKYC: path(ROOTS_DASHBOARD, "/vendor/pending-kyc"),
    pending_vendor: path(ROOTS_DASHBOARD, "/vendor/pending"),
    rejected_vendor: path(ROOTS_DASHBOARD, "/vendor/rejected"),
    not_uploaded_kyc: path(ROOTS_DASHBOARD, "/vendor/notUploadedKyc"),
    ngo_charity_item_list: path(ROOTS_DASHBOARD, "/ngo/ngo-charity-item"),
    event_list: path(ROOTS_DASHBOARD, "/event/event-list"),
    eventTransactionList: path(ROOTS_DASHBOARD, "/event/event-transaction"),
    donationTransactionList: path(ROOTS_DASHBOARD, "/ngo/donation-transaction"),
    pendingPayout: path(ROOTS_DASHBOARD, "/payout/pending-payout"),
    approvedPayout: path(ROOTS_DASHBOARD, "/payout/approved-payout"),
    transactionList: path(ROOTS_DASHBOARD, "/payout/transaction-list"),
    appVersion: path(ROOTS_DASHBOARD, "/app-version"),
    coupon: path(ROOTS_DASHBOARD, "/coupon"),
    notification: path(ROOTS_DASHBOARD, "/notification"),
    supportTicket: path(ROOTS_DASHBOARD, "/support-ticket"),
    foodOrder: path(ROOTS_DASHBOARD, "/food-order"),
    foodDishList: path(ROOTS_DASHBOARD, "/food-dish"),
    foodDisputedOrder: path(ROOTS_DASHBOARD, "/food-disputed-order"),
    groceryList: path(ROOTS_DASHBOARD, "/grocery-list"),
    groceryDisputedOrder: path(ROOTS_DASHBOARD, "/grocery-disputed-order"),
    groceryOrder: path(ROOTS_DASHBOARD, "/grocery-order"),
    orderDetail: path(ROOTS_DASHBOARD, "/order-detail"),
    disputedOrder: path(ROOTS_DASHBOARD, "/disputed-order"),
    adminfees: path(ROOTS_DASHBOARD, "/admin-fees"),
    cmsPages: path(ROOTS_DASHBOARD, "/cms-pages"),
    // orderDetail: path(ROOTS_DASHBOARD, "/orger-detail"),
    viewVendor: path(ROOTS_DASHBOARD, "/vendor/approved/view"),
    
    payoutTransaction: path(ROOTS_DASHBOARD, "/payout/transaction"),
    
    pending_kyc_vendor: path(ROOTS_DASHBOARD, "/vendor/pending-kyc"),
    pending_bank_vendor: path(ROOTS_DASHBOARD, "/vendor/pending-bank"),
    changeBankVendor: path(ROOTS_DASHBOARD, "/vendor/change-bank"),
    viewSupportRequest: path(ROOTS_DASHBOARD, "/support-ticket/view"),
    editSupportRequest: path(ROOTS_DASHBOARD, "/support-ticket/edit"),
    supportSubject: path(ROOTS_DASHBOARD, "/support-subject"),
    advertisement: path(ROOTS_DASHBOARD, "/advertisement"),
    
    viewPayoutOrder: path(ROOTS_DASHBOARD, "/payout-order-view"),
    viewPayoutEventBooking: path(ROOTS_DASHBOARD, "/payout-event-view"),
    viewPayoutNGODOnation: path(ROOTS_DASHBOARD, "/payout-charity-view"),
    FAQ: path(ROOTS_DASHBOARD, "/faq"),
    Subscriber: path(ROOTS_DASHBOARD, "/subscriber"),
    feedback: path(ROOTS_DASHBOARD, "/feedback"),
    MasterPassword: path(ROOTS_DASHBOARD, "/master-password"),

  },
};
export const HOME_PAGE_PATH = {
  root: ROOTS_AUTH,
};

export const PATH_DOCS = "https://docs-minimals.vercel.app/introduction";
